import Immutable from 'immutable';
import * as ActionTypes from 'constants/ActionTypes';

const initialState = {
  data: Immutable.List(),
  isFetching: false,
};

export default function fictivePortfolios(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FICTIVE_PORTFOLIOS_REQUEST_DATA:
      return Object.assign({}, state, {
        isFetching: true,
        data: Immutable.List(),
      });
    case ActionTypes.FICTIVE_PORTFOLIOS_RECEIVE_DATA:
      return Object.assign({}, state, {
        isFetching: false,
        data: Immutable.List(action.data),
      });
    default:
      return state;
  }
}
